import { takeEvery } from 'redux-saga/effects'
import * as Sentry from '@sentry/browser'

import { DID } from 'app/constants/identityActions'
import { showSuccess } from 'store/entities/toastr/utils'
import * as STAGES from 'app/constants/stages'
import { ACTIVITY_COMMITED, ACTIVITY_FINISHED, PREVIOUS_ACTIVITY_FINISHED } from 'app/constants/toastrMessages'
import { activityActions } from '../actions'

export default function* getIdentityProgressSuccess() {
  yield takeEvery(
    [
      activityActions.commit.success.toString(),
      activityActions.did.success.toString(),
      activityActions.didnot.success.toString(),
      activityActions.complete.success.toString(),
    ],
    getIdentityProgressSuccessHandler
  )
}

export function getIdentityProgressSuccessHandler({
  payload: { data },
  meta: {
    request: { data: requestedData },
  },
}) {
  if (!data) {
    return
  }
  try {
    if (data.stage === STAGES.PROCEED || data.stage === STAGES.DONE) {
      const { activity, lastActivity } = data
      const isPrevActivity = lastActivity && lastActivity.userActivityId === requestedData.userActivityId
      // activity is null here when user has day off today but commit/committed from email or from somewhere else.
      const isTodayActivity = activity && activity.userActivityId === requestedData.userActivityId
      if (isTodayActivity) {
        const content = requestedData.actionType === DID ? ACTIVITY_FINISHED : ACTIVITY_COMMITED
        showSuccess({ content })
      }
      if (isPrevActivity && requestedData.actionType === DID) {
        // we can't did commit for prev activity
        showSuccess({ content: PREVIOUS_ACTIVITY_FINISHED })
      }
    }
  } catch (e) {
    console.log('__error__', e)
    console.log('__response__', response)
    let response
    try {
      response = JSON.stringify(data)
    } catch (e) {
      response = data
    }
    Sentry.withScope(scope => {
      scope.setExtra('response', response)
      scope.setExtra('where error was happen', 'getIdentityProgressSuccessHandler')
      Sentry.captureException(e)
    })
  }
}
